<div class="alerts">
    @if (isLoading()) {
        @for (skeleton of alertSkeletonItems; track skeleton) {
            <div class="alerts__item">
                <div class="skeleton skeleton-value"></div>
                <div class="skeleton skeleton-label"></div>
            </div>
        }
    } @else {
        @for (alert of alerts(); track alert.title) {
            <div class="alerts__item" [class.alerts__item--emphasis]="alert.emphasis">
                @if (alert.leadIds?.length) {
                    <a
                        class="alerts__value alerts__value-link"
                        [routerLink]="['/crm/lead-dashboard']"
                        [queryParams]="getAlertValueQueryParams(alert)"
                    >
                        {{ alert.value }}
                    </a>
                } @else {
                    <div class="alerts__value">
                        {{ alert.value }}
                    </div>
                }
                <div class="alerts__title">{{ alert.title }}</div>
            </div>
        }
    }
</div>
